<template>
    <div v-if="isShowing"
         class="comment-reply"
         :id="idSelector"
         :class="{'comment-reply--focus': isActive}">

        <editor-content v-if="isActive"
                        :editor="editor"
                        class="comment-reply__text comment-reply__text--focus"
        />
        <div v-else
             class="comment-reply__text"
             @click="activateForm">
            <span class="comment-reply__placeholder">Написать комментарий</span>
        </div>

        <div v-if="isActive"
             class="comment-reply__attaches comment-reply__attaches--focus">

            <div class="comment-reply__attach-image"></div>
            <div class="comment-reply__attach-gif"></div>
            <div class="comment-reply__attach-emoji" v-if="!$isMobile()">
                <VueTwemojiPicker @selected="addEmoji"/>
            </div>

        </div>
        <div v-if="isActive" class="comment-reply__actions comment-reply__actions--focus">
            <div @click="cancel" class="comment-reply__cancel">
                Отменить
            </div>
            <div @click="send" class="comment-reply__send">
                {{btnText}}
            </div>
        </div>
    </div>
</template>

<script>
    import twemoji from "twemoji";
    import $ from 'jquery';
    import {Editor, EditorContent} from 'tiptap'
    import Bold from './mark/Bold'
    import Image from './node/Image'
    import {
        CANCEL_COMMENT_EDITING_ACTION,
        CREATE_COMMENT_ACTION,
        UPDATE_COMMENT_ACTION
    } from "VueApps/comments/actions/actions";
    import {getUniqueId} from "VueApps/comments/services/getIdForInput";
    import {isHtmlEmpty, replaceEmojiWithAltAttribute} from "VueApps/comments/services/textParser";
    import VueTwemojiPicker from "VueApps/comments/components/input/VueTwemojiPicker.vue";

    export default {
        name: "Input",
        components: {
            VueTwemojiPicker,
            EditorContent,
        },
        props: {
            answerToId: {
                required: false,
                type: Number,
                default: null,
            }
        },
        data() {
            return {
                editor: null,
                isActive: false,
                isAttachesBlockActive: false,
                isEmojiListActive: false
            }
        },
        computed: {
            isShowing: function () {
                if (this.isMainInput) {
                    return true;
                }

                const selectedId = this.$store.state.selectedAnswerToId;

                return null !== selectedId && this.answerToId === selectedId;
            },
            isMainInput: function () {
                return null === this.answerToId;
            },
            isEditing: function () {
                return this.isShowing && !this.isMainInput && this.$store.state.isEditing;
            },
            editText: function () {
                return this.isEditing ?
                    this.$store.state.editingText :
                    null;
            },
            btnText: function () {
                if (this.isCommentEmpty) {
                    return 'Добавьте текст';
                }

                return this.isEditing ?
                    'Сохранить' :
                    'Отправить';
            },
            idSelector: function () {
                return !this.isMainInput ?
                    getUniqueId(this.$store.state.selectedAnswerToId) :
                    null;
            },
            isCommentEmpty: function () {
                return isHtmlEmpty(this.getCommentText());
            }
        },
        mounted() {
            this.editor = new Editor({
                extensions: [
                    new Image(),
                    new Bold(),
                ],
                content: '<p><br></p>',
            })
        },
        watch: {
            editText: function (newValue) {
                if (newValue) {
                    this.editor.setContent(
                        !this.$isMobile() ? twemoji.parse(newValue) : newValue
                    );

                    this.activateForm();
                }
            },
            isShowing: function (newValue) {
                if (newValue === false) {
                    this.deactivateForm();
                }
            },
        },
        methods: {
            addEmoji(emoji) {
                const image = $(twemoji.parse(emoji));

                this.editor.commands.image({
                    src: image.attr('src'),
                    alt: image.attr('alt'),
                    class: image.attr('class'),
                });
            },
            hideEmojiList: function () {
                this.isEmojiListActive = false;
            },
            getCommentText: function () {
                return replaceEmojiWithAltAttribute(this.editor.getHTML());
            },
            clearEditor: function () {
                this.editor.clearContent(true);
            },
            send: function () {
                if (this.isCommentEmpty) {
                    return;
                }

                let entityId = null;

                if (this.$parent.$el.className === 'comment-replies') {
                    entityId = this.$parent.entityId;
                } else {
                    entityId = this.$parent.$parent.entityId;
                }

                if (this.isEditing) {
                    this.$store.dispatch(UPDATE_COMMENT_ACTION, {
                        commentId: this.answerToId,
                        text: this.getCommentText(),
                        entityId: entityId
                    });
                } else {
                    this.$store.dispatch(CREATE_COMMENT_ACTION, {
                        text: this.getCommentText(),
                        answerToId: this.answerToId,
                        entityId: entityId
                    });
                }

                this.deactivateForm();
            },
            cancel: function () {
                this.deactivateForm();
                this.$store.dispatch(CANCEL_COMMENT_EDITING_ACTION);
            },
            activateForm: function () {
                this.isActive = true;
                this.editor.focus();
            },
            deactivateForm: function () {
                this.isActive = false;
                this.clearEditor();
                this.hideEmojiList();
            },
        },
        beforeDestroy() {
            this.editor.destroy()
        },
    }
</script>

<style scoped>

</style>
